"use strict";

const UIEventImpl = require("./UIEvent-impl").implementation;

const TouchEventInit = require("../generated/TouchEventInit");

class TouchEventImpl extends UIEventImpl {

}
TouchEventImpl.defaultInit = TouchEventInit.convert(undefined, undefined);

module.exports = {
  implementation: TouchEventImpl
};
